(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-story"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.about-story').forEach((section) => {
    section.classList.add('about-story--animate');

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const revealEls = section.querySelectorAll('[data-reveal]');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealEls.forEach((el) => el.classList.add('is-revealed'));
    } else {
      const revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );
      revealEls.forEach((el, index) => {
        el.style.transitionDelay = `${index * 120}ms`;
        revealObserver.observe(el);
      });
    }

    const video = section.querySelector('.about-story__video');
    const media = section.querySelector('.about-story__media');
    const playBtn = section.querySelector('.about-story__play');
    if (!video || !media) return;

    // Muted, looping preview until the visitor presses play.
    video.muted = true;
    video.play().catch(() => {});

    const startFilm = () => {
      media.classList.add('is-playing');
      video.loop = false;
      video.controls = true;
      video.muted = false;
      video.currentTime = 0;
      video.play().catch(() => {
        // Sound blocked for some reason - keep going muted, controls let them unmute.
        video.muted = true;
        video.play().catch(() => {});
      });
    };

    const backToPreview = () => {
      media.classList.remove('is-playing');
      video.controls = false;
      video.muted = true;
      video.loop = true;
      video.currentTime = 0;
      video.play().catch(() => {});
    };

    if (playBtn) playBtn.addEventListener('click', startFilm);
    video.addEventListener('ended', backToPreview);

    // Pause the preview while it's off screen, resume when it scrolls back.
    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (!media.classList.contains('is-playing')) video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.4 }
      );
      videoObserver.observe(media);
    }

    const fsBtn = section.querySelector('.about-story__fullscreen');
    if (fsBtn) {
      fsBtn.addEventListener('click', () => {
        if (document.fullscreenElement) {
          document.exitFullscreen().catch(() => {});
        } else if (media.requestFullscreen) {
          media.requestFullscreen().catch(() => {});
        } else if (video.webkitEnterFullscreen) {
          video.webkitEnterFullscreen();
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bestsellers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-bestsellers]').forEach((section) => {
      section.querySelectorAll('[data-bestsellers-atc]').forEach((btn) => {
        btn.addEventListener('click', async (event) => {
          event.preventDefault();
          event.stopPropagation();

          const variantId = btn.dataset.variantId;
          if (!variantId) return;

          const textEl = btn.querySelector('[data-bestsellers-atc-text]');
          const original = textEl ? textEl.textContent : btn.textContent;
          btn.disabled = true;
          if (textEl) textEl.textContent = 'Adding\u2026';

          const payload = {
            id: Number(variantId),
            quantity: 1
          };

          const planId = btn.dataset.sellingPlanId;
          if (planId) payload.selling_plan = Number(planId);

          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify(payload)
            });
            if (!res.ok) {
              let message = 'Try again';
              try {
                const data = await res.json();
                if (data && data.description) message = data.description;
              } catch (e) { /* non-JSON error body */ }
              throw new Error(message);
            }
            window.location.href = '/cart';
          } catch (err) {
            if (textEl) textEl.textContent = err.message || 'Try again';
            btn.disabled = false;
            setTimeout(() => {
              if (textEl) textEl.textContent = original;
            }, 3500);
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["build-your-pack"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const blocks = document.querySelectorAll('[data-byop]');
    blocks.forEach(initBlock);

    function initBlock(root) {
      const bagCount = parseInt(root.dataset.bagCount, 10) || 3;
      const freeThreshold = parseInt(root.dataset.freeThreshold, 10) || 40;
      const selects = root.querySelectorAll('[data-byop-select]');
      const mainImage = root.querySelector('[data-byop-main-image]');
      const totalEl = root.querySelector('[data-byop-total]');
      const progress = root.querySelector('[data-byop-progress]');
      const progressFill = root.querySelector('[data-byop-progress-fill]');
      const progressLabel = root.querySelector('[data-byop-progress-label]');
      const atc = root.querySelector('[data-byop-atc]');
      const atcText = root.querySelector('[data-byop-atc-text]');
      const purchaseOptions = root.querySelectorAll('[data-byop-purchase]');
      const subRadio = root.querySelector('[data-byop-purchase="subscribe"] input');
      const chips = root.querySelectorAll('[data-byop-chip]');

      let currentPlanId = subRadio && subRadio.checked ? subRadio.dataset.byopPlanId || '' : '';

      function parsePlans(raw) {
        if (!raw) return [];
        return raw.split('||').map(entry => {
          const sep = entry.lastIndexOf('::');
          return sep === -1 ? null : { name: entry.slice(0, sep).trim(), id: entry.slice(sep + 2).trim() };
        }).filter(Boolean);
      }

      function getSelection() {
        const items = [];
        selects.forEach(sel => {
          const opt = sel.options[sel.selectedIndex];
          if (opt && opt.value) {
            items.push({
              variantId: opt.value,
              price: parseInt(opt.dataset.price, 10),
              image: opt.dataset.image,
              title: opt.dataset.title,
              plans: parsePlans(opt.dataset.plans)
            });
          }
        });
        return items;
      }

      // Products can sit in different Recharge plan groups, so a single plan
      // id won't apply across bags. Match each bag's own plan by frequency
      // name (falling back to its first plan) so mixed packs don't 422.
      function planForItem(item) {
        if (!currentPlanId || !item.plans.length) return '';
        const activeChip = root.querySelector('[data-byop-chip].is-active');
        const wantedName = activeChip ? activeChip.textContent.trim() : '';
        const byId = item.plans.find(p => p.id === currentPlanId);
        if (byId) return byId.id;
        const byName = item.plans.find(p => p.name === wantedName);
        if (byName) return byName.id;
        return item.plans[0].id;
      }

      function updateUI() {
        const items = getSelection();
        const total = items.reduce((s, i) => s + i.price, 0);
        if (totalEl) totalEl.textContent = formatMoney(total);

        if (items[0] && items[0].image && mainImage) {
          mainImage.src = items[0].image;
        }

        if (progress && progressFill && progressLabel) {
          const thresholdCents = freeThreshold * 100;
          const pct = Math.min(100, Math.round((total / thresholdCents) * 100));
          progressFill.style.width = pct + '%';
          progressLabel.textContent = formatMoney(total) + ' / \u00A3' + freeThreshold;
          progress.classList.toggle('is-met', total >= thresholdCents);
        }

        const done = items.length >= bagCount;
        if (atc) atc.disabled = !done;
        if (atcText) atcText.textContent = done
          ? 'Add pack to cart \u00B7 ' + formatMoney(total)
          : 'Pick ' + (bagCount - items.length) + ' more bag' + (bagCount - items.length === 1 ? '' : 's');
      }

      function formatMoney(cents) {
        const val = (cents / 100).toFixed(2);
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
            style: 'currency',
            currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP'
          }).format(val);
        } catch (e) { return '\u00A3' + val; }
      }

      selects.forEach(s => s.addEventListener('change', updateUI));

      purchaseOptions.forEach(opt => {
        opt.addEventListener('click', (e) => {
          if (e.target.matches('[data-byop-chip]')) return;
          purchaseOptions.forEach(o => o.classList.remove('is-active'));
          opt.classList.add('is-active');
          const radio = opt.querySelector('input[type="radio"]');
          if (radio) radio.checked = true;
          if (opt.dataset.byopPurchase === 'subscribe') {
            const active = root.querySelector('[data-byop-chip].is-active');
            currentPlanId = (active && active.dataset.byopPlanId) || (subRadio && subRadio.dataset.byopPlanId) || '';
          } else {
            currentPlanId = '';
          }
        });
      });

      chips.forEach(chip => {
        chip.addEventListener('click', () => {
          chips.forEach(c => {
            c.classList.remove('is-active');
            c.setAttribute('aria-checked', 'false');
          });
          chip.classList.add('is-active');
          chip.setAttribute('aria-checked', 'true');
          currentPlanId = chip.dataset.byopPlanId;
          if (subRadio) {
            subRadio.checked = true;
            purchaseOptions.forEach(o => o.classList.toggle('is-active', o.dataset.byopPurchase === 'subscribe'));
          }
        });
      });

      if (atc) {
        atc.addEventListener('click', async () => {
          const items = getSelection();
          if (items.length < bagCount) return;
          atc.disabled = true;
          const original = atcText ? atcText.textContent : '';
          if (atcText) atcText.textContent = 'Adding\u2026';

          const payload = {
            items: items.map(i => {
              const item = { id: i.variantId, quantity: 1 };
              const plan = planForItem(i);
              if (plan) item.selling_plan = plan;
              return item;
            })
          };

          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify(payload)
            });
            if (!res.ok) {
              let message = 'Something went wrong \u2014 try again';
              try {
                const err = await res.json();
                if (err && err.description) message = err.description;
              } catch (e) { /* non-JSON error body */ }
              throw new Error(message);
            }
            window.location.href = '/cart';
          } catch (err) {
            if (atcText) atcText.textContent = err.message || 'Try again';
            atc.disabled = false;
            setTimeout(() => { if (atcText) atcText.textContent = original; }, 3500);
          }
        });
      }

      updateUI();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    // Quantity changes post to /cart/change.js and re-render this section via
    // the Section Rendering API. Delegated handlers survive the HTML swap.
    let pending = false;

    function root() {
      return document.querySelector('[data-cart-page]');
    }

    function renderSection(data, sectionId, focusMessage) {
      const html = data.sections && data.sections[sectionId];
      const wrapper = document.getElementById('shopify-section-' + sectionId);
      if (html && wrapper) {
        wrapper.innerHTML = new DOMParser()
          .parseFromString(html, 'text/html')
          .getElementById('shopify-section-' + sectionId).innerHTML;
      } else {
        window.location.reload();
      }
      if (focusMessage) {
        // The trigger button is replaced by the swap; park focus on the
        // status message so keyboard/screen-reader users land somewhere
        // meaningful and hear the updated delivery state.
        const msg = document.querySelector('[data-fd-message]');
        if (msg) msg.focus();
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
    }

    function updateLine(line, quantity) {
      const page = root();
      if (!page || pending) return;
      const sectionId = page.dataset.sectionId;
      pending = true;
      const items = page.querySelector('.cart-page__items');
      if (items) items.classList.add('is-updating');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: sectionId })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart update failed');
          return res.json();
        })
        .then(function (data) {
          renderSection(data, sectionId);
        })
        .catch(function () {
          window.location.reload();
        })
        .finally(function () {
          pending = false;
        });
    }

    // One-click "switch everything to Subscribe & Save": each one-time line
    // carries its product's default selling plan (first plan of first group -
    // the same default the product page picker uses). Lines are changed by
    // key, sequentially, because Shopify may merge a switched line into an
    // existing subscription line of the same variant.
    function upgradeAllToSubscription(btn) {
      const page = root();
      if (!page || pending) return;
      const lines = Array.prototype.slice.call(page.querySelectorAll('[data-cart-item][data-default-plan]'));
      if (!lines.length) return;
      const sectionId = page.dataset.sectionId;
      pending = true;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Switching\u2026';
      const items = page.querySelector('.cart-page__items');
      if (items) items.classList.add('is-updating');

      let chain = Promise.resolve();
      lines.forEach(function (el, i) {
        chain = chain.then(function () {
          const payload = {
            id: el.dataset.itemKey,
            quantity: parseInt(el.dataset.itemQty, 10) || 1,
            selling_plan: parseInt(el.dataset.defaultPlan, 10)
          };
          if (i === lines.length - 1) payload.sections = sectionId;
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload)
          }).then(function (res) {
            if (!res.ok) throw new Error('Subscription switch failed');
            return res.json();
          });
        });
      });

      chain
        .then(function (data) {
          renderSection(data, sectionId, true);
        })
        .catch(function () {
          window.location.reload();
        })
        .finally(function () {
          pending = false;
        });
    }

    // Change a subscription line's frequency (or drop to one-time when the
    // empty option is chosen). selling_plan: null strips the plan.
    function changeLinePlan(sel) {
      const page = root();
      if (!page || pending) return;
      const sectionId = page.dataset.sectionId;
      pending = true;
      sel.disabled = true;
      const items = page.querySelector('.cart-page__items');
      if (items) items.classList.add('is-updating');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: sel.dataset.itemKey,
          quantity: parseInt(sel.dataset.itemQty, 10) || 1,
          selling_plan: sel.value ? parseInt(sel.value, 10) : null,
          sections: sectionId
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Frequency change failed');
          return res.json();
        })
        .then(function (data) {
          renderSection(data, sectionId);
        })
        .catch(function () {
          window.location.reload();
        })
        .finally(function () {
          pending = false;
        });
    }

    // Celebration: stars + paw prints burst the first time the free-delivery
    // threshold is crossed this session (re-arms if the cart drops back under).
    function checkFreeDeliveryCelebration() {
      const bar = document.querySelector('[data-free-delivery]');
      const KEY = 'wwf-free-delivery-celebrated';
      if (!bar || bar.dataset.complete !== 'true') {
        try { sessionStorage.removeItem(KEY); } catch (e) { /* private mode */ }
        return;
      }
      try {
        if (sessionStorage.getItem(KEY)) return;
        sessionStorage.setItem(KEY, '1');
      } catch (e) { /* private mode: celebrate every render, still harmless */ }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const host = bar.querySelector('[data-fd-burst]');
      if (!host) return;
      const star = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l2.9 6.3 6.6.7-4.9 4.5 1.4 6.5L12 16.9 6 20l1.4-6.5L2.5 9l6.6-.7z"/></svg>';
      const paw = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><ellipse cx="6.5" cy="9" rx="1.9" ry="2.5"/><ellipse cx="12" cy="7" rx="1.9" ry="2.5"/><ellipse cx="17.5" cy="9" rx="1.9" ry="2.5"/><path d="M12 11.5c-3.1 0-5.6 2.5-5.6 5.1 0 1.8 1.4 3.1 3.1 3.1.9 0 1.7-.4 2.5-.4s1.6.4 2.5.4c1.7 0 3.1-1.3 3.1-3.1 0-2.6-2.5-5.1-5.6-5.1z"/></svg>';
      const dot = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="12" r="6"/></svg>';
      const shapes = [
        { svg: star, color: 'var(--color-accent-alt)' },
        { svg: paw, color: 'var(--color-primary)' },
        { svg: dot, color: 'var(--color-accent)' },
        { svg: paw, color: 'var(--color-accent-alt)' },
        { svg: star, color: 'var(--color-primary)' }
      ];
      for (let i = 0; i < 16; i++) {
        const shape = shapes[i % shapes.length];
        const s = document.createElement('span');
        s.innerHTML = shape.svg;
        s.style.color = shape.color;
        s.style.left = (4 + Math.random() * 92) + '%';
        s.style.animationDelay = (Math.random() * 0.5).toFixed(2) + 's';
        s.style.setProperty('--fd-spin', Math.round(Math.random() * 80 - 40) + 'deg');
        host.appendChild(s);
      }
      setTimeout(function () { host.innerHTML = ''; }, 2400);
    }

    document.addEventListener('click', function (e) {
      const upgradeBtn = e.target.closest('[data-fd-upgrade-all]');
      if (upgradeBtn && upgradeBtn.closest('[data-cart-page]')) {
        e.preventDefault();
        upgradeAllToSubscription(upgradeBtn);
        return;
      }
    });

    // The doggy-bag bar sticks directly below the sticky header, whose height
    // depends on the logo size settings - measure it into a CSS var.
    function setHeaderOffset() {
      const header = document.querySelector('[data-header]');
      const wrapper = header ? header.parentElement : null;
      const h = wrapper ? wrapper.offsetHeight : 0;
      document.documentElement.style.setProperty('--wwf-header-h', h + 'px');
    }

    // One-tap upsell add: posts the variant(s) as one-time purchases and
    // re-renders the section so totals, delivery bar and pools all update.
    // The "two treats for a tenner" deal button carries data-variant-ids
    // (comma-separated); single cards carry data-variant-id.
    function addUpsell(btn) {
      const page = root();
      if (!page || pending) return;
      const sectionId = page.dataset.sectionId;
      pending = true;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');

      const ids = (btn.dataset.variantIds || btn.dataset.variantId || '').split(',');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: ids.map(function (id) {
            return { id: parseInt(id, 10), quantity: 1 };
          }),
          sections: sectionId
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Upsell add failed');
          return res.json();
        })
        .then(function (data) {
          renderSection(data, sectionId);
        })
        .catch(function () {
          window.location.reload();
        })
        .finally(function () {
          pending = false;
        });
    }

    document.addEventListener('click', function (e) {
      const addBtn = e.target.closest('[data-upsell-add]');
      if (addBtn && addBtn.closest('[data-cart-page]')) {
        e.preventDefault();
        addUpsell(addBtn);
      }
    });

    // Discount codes: /discount/CODE stores the code in the checkout cookie,
    // then a no-op cart update re-renders the section. Where discounts apply
    // in cart, totals and the applied-codes list update immediately;
    // otherwise the code is honoured at checkout.
    function applyDiscount() {
      const page = root();
      const input = document.querySelector('[data-discount-input]');
      if (!page || !input || pending) return;
      const code = input.value.trim();
      if (!code) return;
      const sectionId = page.dataset.sectionId;
      const btn = document.querySelector('[data-discount-apply]');
      pending = true;
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = 'Applying\u2026';
      }

      fetch('/discount/' + encodeURIComponent(code))
        .then(function () {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ sections: sectionId })
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('Discount apply failed');
          return res.json();
        })
        .then(function (data) {
          renderSection(data, sectionId);
        })
        .catch(function () {
          window.location.reload();
        })
        .finally(function () {
          pending = false;
        });
    }

    document.addEventListener('click', function (e) {
      const applyBtn = e.target.closest('[data-discount-apply]');
      if (applyBtn && applyBtn.closest('[data-cart-page]')) {
        e.preventDefault();
        applyDiscount();
      }
    });

    // Enter in the code field must apply the code, not submit the cart form
    // (implicit submission would hit the checkout button).
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      const input = e.target.closest && e.target.closest('[data-discount-input]');
      if (input && input.closest('[data-cart-page]')) {
        e.preventDefault();
        applyDiscount();
      }
    });

    window.addEventListener('resize', setHeaderOffset);
    window.addEventListener('load', setHeaderOffset);
    setHeaderOffset();


    document.addEventListener('cart:updated', checkFreeDeliveryCelebration);
    checkFreeDeliveryCelebration();

    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-cart-qty-btn]');
      if (!btn || !btn.closest('[data-cart-page]')) return;
      e.preventDefault();
      const input = btn.parentElement.querySelector('[data-qty-input]');
      const current = input ? parseInt(input.value, 10) || 0 : 0;
      const next = Math.max(0, current + parseInt(btn.dataset.change, 10));
      updateLine(parseInt(btn.dataset.line, 10), next);
    });

    document.addEventListener('click', function (e) {
      const sw = e.target.closest('[data-fd-switch-line]');
      if (!sw || !sw.closest('[data-cart-page]')) return;
      e.preventDefault();
      sw.disabled = true;
      changeLinePlan({
        value: sw.dataset.fdSwitchLine,
        dataset: { itemKey: sw.dataset.itemKey, itemQty: sw.dataset.itemQty },
        set disabled(v) { sw.disabled = v; }
      });
    });

    document.addEventListener('change', function (e) {
      const planSelect = e.target.closest('[data-plan-select]');
      if (planSelect && planSelect.closest('[data-cart-page]')) {
        changeLinePlan(planSelect);
        return;
      }
      const input = e.target.closest('[data-qty-input]');
      if (!input || !input.closest('[data-cart-page]')) return;
      const qty = Math.max(0, parseInt(input.value, 10) || 0);
      updateLine(parseInt(input.dataset.line, 10), qty);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Everything here is delegated / re-queried live rather than bound to
  // specific nodes so it survives the theme editor re-rendering the section.
  // NOTE: keep this block ASCII-only - see memory / CLI dev-server quirk.
  const siteHeader = document.querySelector('[data-header]');
  const headerH = () => (siteHeader ? siteHeader.getBoundingClientRect().height : 0);

  // Pin below the sticky site header: measure it and expose the offset as
  // a CSS var (used by the sub-nav's `top` and the anchor's scroll-margin).
  const setOffset = () => {
    document.documentElement.style.setProperty('--subnav-top', headerH() + 'px');
  };
  setOffset();
  window.addEventListener('resize', setOffset);

  // Shadow once the bar is actually pinned.
  let ticking = false;
  const checkStuck = () => {
    ticking = false;
    const subnav = document.querySelector('[data-subnav]');
    if (subnav) subnav.classList.toggle('is-stuck', subnav.getBoundingClientRect().top <= headerH() + 1);
  };
  window.addEventListener('scroll', () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(checkStuck);
    }
  }, { passive: true });
  checkStuck();

  // ---------------------------------------------------------------------
  // Dropdown panels. Panels are position: fixed so the horizontally
  // scrollable bar can't clip them - placed under their toggle on open.
  const closeAll = (except) => {
    document.querySelectorAll('[data-subnav-dd]').forEach((dd) => {
      if (dd === except) return;
      const t = dd.querySelector('[data-subnav-dd-toggle]');
      const p = dd.querySelector('[data-subnav-dd-panel]');
      if (t) t.setAttribute('aria-expanded', 'false');
      if (p) p.hidden = true;
    });
  };

  const positionPanel = (toggle, panel) => {
    const rect = toggle.getBoundingClientRect();
    panel.style.top = rect.bottom + 6 + 'px';
    panel.style.left = Math.max(8, Math.min(rect.left, window.innerWidth - panel.offsetWidth - 8)) + 'px';
  };

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });

  // Scroll the page so the filter bar sits directly under the sticky
  // header when a filter is changed - no-op once it is already pinned.
  let pinning = 0;
  const pinSubnav = () => {
    const subnav = document.querySelector('[data-subnav]');
    if (!subnav) return;
    const delta = subnav.getBoundingClientRect().top - headerH();
    if (Math.abs(delta) <= 1) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    pinning = Date.now();
    window.scrollBy({ top: delta, behavior: reduce ? 'auto' : 'smooth' });
  };

  // While the programmatic scroll runs, keep any open panel under its
  // toggle instead of closing it.
  const repositionOpen = () => {
    document.querySelectorAll('[data-subnav-dd]').forEach((dd) => {
      const t = dd.querySelector('[data-subnav-dd-toggle]');
      const p = dd.querySelector('[data-subnav-dd-panel]');
      if (t && p && !p.hidden) positionPanel(t, p);
    });
  };

  // A fixed panel would drift away from its toggle - just close on scroll.
  // Capture phase also catches the sub-nav bar's own horizontal scroll.
  window.addEventListener('scroll', () => {
    if (pinning && Date.now() - pinning < 1200) { repositionOpen(); return; }
    pinning = 0;
    closeAll();
  }, { passive: true });
  document.addEventListener('scroll', (e) => {
    if (e.target && e.target.closest && e.target.closest('.c-subnav__inner')) closeAll();
  }, { capture: true, passive: true });

  // ---------------------------------------------------------------------
  // Faceted filtering. State = { facet: Set(values) }. A card matches when,
  // for every facet with selections, at least one selected value is in the
  // card's data-f-<facet> list (OR within a group, AND across groups).
  const FACETS = ['protein', 'size', 'type', 'stage'];
  const state = {};
  FACETS.forEach((f) => { state[f] = new Set(); });

  const cards = () => Array.from(document.querySelectorAll('[data-filter-grid] [data-facet-card]'));
  const cardValues = (card, facet) => (card.getAttribute('data-f-' + facet) || '').split(' ').filter(Boolean);
  const cardHas = (card, facet, value) => cardValues(card, facet).indexOf(value) !== -1;

  const matches = (card, ignoreFacet) => FACETS.every((f) => {
    if (f === ignoreFacet || state[f].size === 0) return true;
    return cardValues(card, f).some((v) => state[f].has(v));
  });

  const activeCount = () => FACETS.reduce((n, f) => n + state[f].size, 0);

  const readState = () => {
    const params = new URLSearchParams(window.location.search);
    FACETS.forEach((f) => {
      state[f] = new Set((params.get(f) || '').split(',').filter(Boolean));
    });
  };

  const writeState = (push) => {
    const url = new URL(window.location.href);
    FACETS.forEach((f) => {
      if (state[f].size) url.searchParams.set(f, Array.from(state[f]).join(','));
      else url.searchParams.delete(f);
    });
    url.searchParams.delete('page');
    if (url.href === window.location.href) return;
    if (push) history.pushState({ wwfFilters: true }, '', url.href);
    else history.replaceState({ wwfFilters: true }, '', url.href);
  };

  const plural = (n) => n + (n === 1 ? ' product' : ' products');

  const apply = () => {
    const all = cards();
    if (!all.length) return;

    let shown = 0;
    all.forEach((card) => {
      const ok = matches(card);
      card.hidden = !ok;
      if (ok) shown += 1;
    });

    // Per-option counts: what you'd get if you (also) ticked this option.
    // Options with no products at all in this collection are hidden.
    document.querySelectorAll('[data-filter-input], [data-filter-chip]').forEach((ctrl) => {
      const facet = ctrl.getAttribute('data-facet');
      const value = ctrl.value;
      const base = all.filter((c) => cardHas(c, facet, value));
      const n = base.filter((c) => matches(c, facet)).length;
      const selected = state[facet].has(value);
      const host = ctrl.closest('[data-filter-opt]') || ctrl;
      const row = ctrl.closest('[data-filter-opt-row]');
      const catLink = row ? row.querySelector('[data-filter-cat-link]') : null;
      host.hidden = base.length === 0;
      if (catLink) catLink.hidden = base.length > 0;
      if (row) row.hidden = host.hidden && (!catLink || catLink.hidden);
      const nEl = host.querySelector('[data-filter-n]');
      if (nEl) nEl.textContent = n;
      if (ctrl.hasAttribute('data-filter-input')) ctrl.checked = selected;
      else ctrl.setAttribute('aria-pressed', String(selected));
    });

    // Hide a whole sheet group when none of its options apply here.
    document.querySelectorAll('[data-filter-sheet-group]').forEach((group) => {
      const any = Array.from(group.querySelectorAll('[data-filter-opt], [data-filter-cat-link]')).some((o) => !o.hidden);
      group.hidden = !any;
    });

    // Group buttons: "Protein" -> "Protein (2)", age: "Puppy, Senior".
    document.querySelectorAll('[data-filter-group-btn]').forEach((btn) => {
      const facet = btn.getAttribute('data-filter-group-btn');
      const labelEl = btn.querySelector('[data-filter-group-label]');
      const sel = state[facet];
      btn.classList.toggle('is-active', sel.size > 0);
      btn.classList.toggle('is-selected', sel.size > 0);
      if (!labelEl) return;
      if (sel.size === 0) {
        labelEl.textContent = btn.getAttribute('data-label');
      } else if (facet === 'stage') {
        const names = [];
        btn.closest('[data-subnav-dd]').querySelectorAll('[data-filter-input]').forEach((i) => {
          if (sel.has(i.value)) names.push(i.closest('[data-filter-opt]').querySelector('.c-filter__label').textContent);
        });
        labelEl.textContent = names.join(', ');
      } else {
        labelEl.textContent = btn.getAttribute('data-label') + ' (' + sel.size + ')';
      }
    });

    const active = activeCount();
    const total = all.length;
    document.querySelectorAll('[data-filter-count]').forEach((el) => {
      el.textContent = active ? 'Showing ' + shown + ' of ' + total : '';
    });
    document.querySelectorAll('.c-subnav__clear[data-filter-clear]').forEach((el) => { el.hidden = active === 0; });

    const mobileLabel = document.querySelector('[data-filter-mobile-label]');
    if (mobileLabel) mobileLabel.textContent = active ? 'Filters (' + active + ')' : 'Filters';
    const mobileBtn = document.querySelector('[data-filter-open]');
    if (mobileBtn) mobileBtn.classList.toggle('is-active', active > 0);
    const applyBtn = document.querySelector('[data-filter-apply-label]');
    if (applyBtn) applyBtn.textContent = 'Show ' + plural(shown);

    const empty = document.querySelector('[data-filter-empty]');
    if (empty) empty.hidden = shown > 0;

    // Keep any open dropdown panel under its toggle after label changes.
    document.querySelectorAll('[data-subnav-dd]').forEach((dd) => {
      const t = dd.querySelector('[data-subnav-dd-toggle]');
      const p = dd.querySelector('[data-subnav-dd-panel]');
      if (t && p && !p.hidden) positionPanel(t, p);
    });
  };

  const toggleValue = (facet, value) => {
    if (!state[facet]) return;
    if (state[facet].has(value)) state[facet].delete(value);
    else state[facet].add(value);
    writeState(true);
    apply();
    pinSubnav();
  };

  const clearAll = () => {
    FACETS.forEach((f) => state[f].clear());
    writeState(true);
    apply();
    pinSubnav();
  };

  // Collections longer than one page: pull the remaining pages of cards in
  // the background so filtering covers every product, then drop the
  // pagination links.
  const loadRemainingPages = () => {
    const grid = document.querySelector('[data-filter-grid]');
    if (!grid || grid.getAttribute('data-pages-loaded')) return;
    const pages = parseInt(grid.getAttribute('data-pages') || '1', 10);
    if (pages <= 1) return;
    grid.setAttribute('data-pages-loaded', '1');
    const base = new URL(window.location.href);
    FACETS.forEach((f) => base.searchParams.delete(f));
    const requests = [];
    for (let i = 2; i <= pages; i += 1) {
      base.searchParams.set('page', String(i));
      requests.push(fetch(base.href).then((r) => (r.ok ? r.text() : '')).catch(() => ''));
    }
    Promise.all(requests).then((htmls) => {
      const frag = document.createDocumentFragment();
      htmls.forEach((html) => {
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('[data-filter-grid] [data-facet-card]').forEach((c) => frag.appendChild(c));
      });
      const empty = grid.querySelector('[data-filter-empty]');
      grid.appendChild(frag);
      if (empty) grid.appendChild(empty);
      const pag = document.querySelector('[data-filter-pagination]');
      if (pag) pag.hidden = true;
      apply();
    });
  };

  // Mobile sheet
  const sheet = () => document.querySelector('[data-filter-sheet]');
  const openSheet = () => {
    const d = sheet();
    if (d && !d.open) d.showModal();
  };
  const closeSheet = () => {
    const d = sheet();
    if (d && d.open) d.close();
  };

  document.addEventListener('change', (e) => {
    const input = e.target.closest && e.target.closest('[data-filter-input]');
    if (!input) return;
    toggleValue(input.getAttribute('data-facet'), input.value);
  });

  document.addEventListener('click', (e) => {
    // Dropdown toggles first.
    const toggle = e.target.closest('[data-subnav-dd-toggle]');
    if (toggle) {
      const dd = toggle.closest('[data-subnav-dd]');
      const panel = dd.querySelector('[data-subnav-dd-panel]');
      const open = toggle.getAttribute('aria-expanded') === 'true';
      closeAll(dd);
      toggle.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
      if (!open) { positionPanel(toggle, panel); pinSubnav(); }
      return;
    }

    const chip = e.target.closest('[data-filter-chip]');
    if (chip) {
      toggleValue(chip.getAttribute('data-facet'), chip.value);
      return;
    }

    if (e.target.closest('[data-filter-clear]')) {
      clearAll();
      return;
    }

    if (e.target.closest('[data-filter-open]')) {
      closeAll();
      openSheet();
      return;
    }

    if (e.target.closest('[data-filter-close]')) {
      closeSheet();
      return;
    }

    // Tap on the sheet's backdrop closes it.
    const d = sheet();
    if (d && d.open && e.target === d) {
      closeSheet();
      return;
    }

    if (!e.target.closest('[data-subnav-dd]')) closeAll();
  });

  // Back/forward restores the filters encoded in the URL.
  window.addEventListener('popstate', () => {
    readState();
    apply();
  });

  readState();
  apply();
  loadRemainingPages();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-popup"]) return;
  try {
    
  (function () {
    var popup = document.querySelector('[data-email-popup]');
    if (!popup) return;

    var STORAGE_KEY = 'wwf-email-popup';
    var card = popup.querySelector('.wf-popup__card');
    var teaser = document.querySelector('[data-email-popup-teaser]');
    var teaserEnabled = popup.getAttribute('data-teaser') === 'true' && !!teaser;
    var delay = parseFloat(popup.getAttribute('data-trigger-delay'));
    var exitIntent = popup.getAttribute('data-trigger-exit') === 'true';
    var scrollPct = parseInt(popup.getAttribute('data-trigger-scroll'), 10) || 0;
    var frequencyDays = parseFloat(popup.getAttribute('data-frequency-days')) || 7;
    var designMode = !!(window.Shopify && window.Shopify.designMode);

    var isOpen = false;
    var triggered = false;
    var lastFocus = null;

    function readState() {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') || {};
      } catch (e) {
        return {};
      }
    }

    function writeState(patch) {
      var state = readState();
      for (var k in patch) state[k] = patch[k];
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
    }

    function showTeaser() {
      if (!teaserEnabled) return;
      teaser.hidden = false;
    }

    function hideTeaser() {
      if (!teaser) return;
      teaser.hidden = true;
    }

    function open() {
      if (isOpen) return;
      isOpen = true;
      triggered = true;
      lastFocus = document.activeElement;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      hideTeaser();
      var email = popup.querySelector('[data-popup-email]');
      var target = email || card;
      window.setTimeout(function () { target.focus({ preventScroll: true }); }, 250);
    }

    function close(remember) {
      if (!isOpen) return;
      isOpen = false;
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (remember !== false) writeState({ dismissedAt: new Date().getTime() });
      if (!readState().subscribed) showTeaser();
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    // Close targets inside the modal
    popup.querySelectorAll('[data-popup-close]').forEach(function (el) {
      el.addEventListener('click', function () { close(); });
    });

    // Any opener elsewhere on the page (announcement bar, footer link, etc.)
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-email-popup-open]');
      if (!opener) return;
      e.preventDefault();
      open();
    });

    if (teaser) {
      teaser.addEventListener('click', function () { open(); });
    }

    // Keyboard: Escape closes, Tab stays inside the card
    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') {
        close();
        return;
      }
      if (e.key !== 'Tab') return;
      var focusable = card.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    // Copy discount code
    var copyBtn = popup.querySelector('[data-popup-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.getAttribute('data-code') || '';
        var label = copyBtn.querySelector('[data-copy-label]');
        var done = function () {
          copyBtn.classList.add('is-copied');
          if (label) label.textContent = 'Copied';
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          done();
        }
      });
    }

    // Theme editor: open when the merchant selects this section
    if (designMode) {
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target.contains(popup)) open();
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target.contains(popup)) close(false);
      });
    }

    // --- Decide what to do on this page load ---
    var state = readState();
    var justSubscribed = window.location.search.indexOf('customer_posted=true') !== -1
      && !!popup.querySelector('[data-popup-success]');
    var hasError = !!popup.querySelector('[data-popup-error]');

    if (justSubscribed) {
      writeState({ subscribed: true });
      hideTeaser();
      open();
      return;
    }

    if (hasError) {
      open();
      return;
    }

    if (state.subscribed) return;

    var since = state.dismissedAt ? (new Date().getTime() - state.dismissedAt) / 86400000 : Infinity;
    if (since < frequencyDays) {
      showTeaser();
      return;
    }

    if (designMode) return;

    function fire() {
      if (triggered) return;
      open();
    }

    if (!isNaN(delay) && delay >= 0) {
      window.setTimeout(fire, delay * 1000);
    }

    if (scrollPct > 0) {
      var onScroll = function () {
        var doc = document.documentElement;
        var max = doc.scrollHeight - window.innerHeight;
        if (max <= 0) return;
        if ((window.scrollY / max) * 100 >= scrollPct) {
          window.removeEventListener('scroll', onScroll);
          fire();
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    if (exitIntent && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var onLeave = function (e) {
        if (e.clientY <= 0) {
          document.removeEventListener('mouseleave', onLeave);
          fire();
        }
      };
      document.addEventListener('mouseleave', onLeave);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  // FAQ accordion: animates <details> open/close, supports single-open mode,
  // live search with highlighting, and sidebar nav active state.
  // NOTE: keep this block ASCII-only (Shopify CLI dev bundle truncates on multibyte chars).
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initFaq(root) {
      if (root.dataset.faqReady) return;
      root.dataset.faqReady = '1';

      var mode = root.dataset.faqMode || 'multi';
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));

      function animate(details, opening) {
        var wrap = details.querySelector('[data-faq-answer]');
        if (!wrap || reduceMotion || typeof wrap.animate !== 'function') {
          if (opening) details.open = true; else details.open = false;
          return;
        }
        if (details._faqAnim) details._faqAnim.cancel();
        if (opening) {
          details.open = true;
          var end = wrap.scrollHeight;
          wrap.style.overflow = 'hidden';
          details._faqAnim = wrap.animate(
            [{ height: '0px', opacity: 0 }, { height: end + 'px', opacity: 1 }],
            { duration: 280, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
          );
          details._faqAnim.onfinish = function () { wrap.style.height = ''; wrap.style.overflow = ''; details._faqAnim = null; };
        } else {
          var start = wrap.scrollHeight;
          details._faqAnim = wrap.animate(
            [{ height: start + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
            { duration: 220, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
          );
          details._faqAnim.onfinish = function () {
            details.open = false;
            wrap.style.height = '';
            details._faqAnim = null;
          };
        }
      }

      items.forEach(function (details) {
        var summary = details.querySelector('summary');
        if (!summary) return;
        summary.addEventListener('click', function (e) {
          e.preventDefault();
          var opening = !details.open;
          if (opening && mode === 'single') {
            items.forEach(function (other) {
              if (other !== details && other.open) animate(other, false);
            });
          }
          animate(details, opening);
        });
      });

      // Deep link: /pages/faq#faq-q-<block id> opens that question
      function openFromHash() {
        var hash = window.location.hash;
        if (!hash) return;
        var target;
        try { target = root.querySelector(hash); } catch (err) { target = null; }
        if (target && target.hasAttribute('data-faq-item') && !target.open) {
          target.open = true;
          target.scrollIntoView({ block: 'center' });
        }
      }
      openFromHash();
      window.addEventListener('hashchange', openFromHash);

      // Search
      var input = root.querySelector('[data-faq-search]');
      var empty = root.querySelector('[data-faq-empty]');
      var groups = Array.prototype.slice.call(root.querySelectorAll('[data-faq-group]'));

      function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

      function highlight(el, term) {
        var text = el.getAttribute('data-faq-raw');
        if (text === null) { text = el.textContent; el.setAttribute('data-faq-raw', text); }
        if (!term) { el.textContent = text; return; }
        var re = new RegExp('(' + escapeRe(term) + ')', 'ig');
        var html = text.replace(/[&<>]/g, function (c) {
          return c === '&' ? '&amp;' : c === '<' ? '&lt;' : '&gt;';
        }).replace(re, '<mark>$1</mark>');
        el.innerHTML = html;
      }

      if (input) {
        input.addEventListener('input', function () {
          var term = input.value.trim().toLowerCase();
          var visible = 0;
          items.forEach(function (details) {
            var qEl = details.querySelector('.faq__question-text');
            var hay = (details.textContent || '').toLowerCase();
            var match = !term || hay.indexOf(term) !== -1;
            details.hidden = !match;
            if (match) visible++;
            if (qEl) highlight(qEl, term);
            if (term && match && !details.open) details.open = true;
          });
          groups.forEach(function (g) {
            var any = g.querySelector('[data-faq-item]:not([hidden])');
            g.hidden = !any;
          });
          if (empty) empty.hidden = visible !== 0;
        });
      }

      // Sidebar nav active state
      var navLinks = Array.prototype.slice.call(root.querySelectorAll('[data-faq-nav-link]'));
      if (navLinks.length && 'IntersectionObserver' in window) {
        var map = {};
        navLinks.forEach(function (a) { map[a.getAttribute('href').slice(1)] = a; });
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            navLinks.forEach(function (a) { a.classList.remove('is-active'); });
            var link = map[entry.target.id];
            if (link) link.classList.add('is-active');
          });
        }, { rootMargin: '-20% 0px -60% 0px' });
        groups.forEach(function (g) { if (g.id) io.observe(g); });
      }
    }

    function initAll() {
      document.querySelectorAll('[data-faq]').forEach(initFaq);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Theme editor: re-init when the section is re-rendered
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-faq]') : null;
      if (root) initFaq(root);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var d = e.target && e.target.closest ? e.target.closest('[data-faq-item]') : null;
      if (d) d.open = true;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('[data-header]');
  const menuToggle = header.querySelector('[data-menu-toggle]');
  const menuClose = header.querySelector('[data-menu-close]');
  const mobileNav = header.querySelector('[data-mobile-nav]');

  // On Recharge portal pages, point the header's Log out button at the
  // portal's own logout link (which ends the token session) once it exists;
  // until then it falls back to /account/logout.
  const portalLogout = header.querySelector('[data-portal-logout]');
  if (portalLogout) {
    const adoptPortalLogoutLink = () => {
      const link = document.querySelector('a[href*="/tools/recurring"][href*="logout"]:not([data-portal-logout])');
      if (link && link.href) {
        portalLogout.href = link.href;
        return true;
      }
      return false;
    };
    if (!adoptPortalLogoutLink()) {
      const logoutObserver = new MutationObserver(() => {
        if (adoptPortalLogoutLink()) logoutObserver.disconnect();
      });
      logoutObserver.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => logoutObserver.disconnect(), 15000);
    }
  }

  // Mobile takeover menu: open/close + scroll lock + expandable call-outs
  const setMenuOpen = (open) => document.documentElement.classList.toggle('mnav-open', open);
  const menuScroll = mobileNav.querySelector('[data-mnav-scroll]');
  const menuItems = Array.from(mobileNav.querySelectorAll('[data-mnav-item]'));

  const setItemOpen = (item, open) => {
    item.classList.toggle('is-open', open);
    const btn = item.querySelector('[data-mnav-toggle]');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  menuItems.forEach((item) => {
    const btn = item.querySelector('[data-mnav-toggle]');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const willOpen = !item.classList.contains('is-open');
      menuItems.forEach((other) => { if (other !== item) setItemOpen(other, false); });
      setItemOpen(item, willOpen);
      if (willOpen && menuScroll) {
        setTimeout(() => {
          const top = btn.getBoundingClientRect().top - menuScroll.getBoundingClientRect().top;
          if (top < 0 || top > menuScroll.clientHeight * 0.5) {
            menuScroll.scrollTo({ top: menuScroll.scrollTop + top - 8, behavior: 'smooth' });
          }
        }, 60);
      }
    });
  });

  // Nested groups inside a panel (By dog / By protein ...): one open at a time per panel
  mobileNav.querySelectorAll('[data-mnav-group-toggle]').forEach((btn) => {
    const group = btn.closest('[data-mnav-group]');
    btn.addEventListener('click', () => {
      const willOpen = !group.classList.contains('is-open');
      const siblings = group.parentElement.querySelectorAll(':scope > [data-mnav-group].is-open');
      siblings.forEach((other) => {
        if (other === group) return;
        other.classList.remove('is-open');
        const t = other.querySelector('[data-mnav-group-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      group.classList.toggle('is-open', willOpen);
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  });

  const openMenu = () => {
    if (mobileNav.open) return;
    if (menuScroll) menuScroll.scrollTop = 0;
    menuItems.forEach((item) => setItemOpen(item, item.hasAttribute('data-mnav-default-open')));
    mobileNav.querySelectorAll('[data-mnav-group].is-open').forEach((g) => {
      g.classList.remove('is-open');
      const t = g.querySelector('[data-mnav-group-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
    mobileNav.showModal();
    setMenuOpen(true);
  };

  menuToggle.addEventListener('click', openMenu);
  menuClose.addEventListener('click', () => mobileNav.close());
  mobileNav.addEventListener('close', () => setMenuOpen(false));
  mobileNav.addEventListener('click', (e) => {
    if (e.target === mobileNav) { mobileNav.close(); return; }
    // Hand off to the search dialog (search.js listens on document) without stacking modals
    if (e.target.closest('[data-search-open]')) mobileNav.close();
  });

  // Accessible mega-menu dropdowns (disclosure pattern)
  const dropdowns = header.querySelectorAll('[data-dropdown]');
  dropdowns.forEach((dd) => {
    const toggle = dd.querySelector('[data-dropdown-toggle]');
    const panel = dd.querySelector('[data-dropdown-panel]');
    if (!toggle || !panel) return;

    const items = () => Array.from(panel.querySelectorAll('a'));

    const open = () => {
      dropdowns.forEach((other) => {
        if (other !== dd) {
          other.classList.remove('is-open');
          const t = other.querySelector('[data-dropdown-toggle]');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
      dd.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    };

    const close = () => {
      dd.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    };

    toggle.addEventListener('click', () => {
      dd.classList.contains('is-open') ? close() : open();
    });

    toggle.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown' || e.key === 'Down') {
        e.preventDefault();
        open();
        const first = items()[0];
        if (first) first.focus();
      }
    });

    panel.addEventListener('keydown', (e) => {
      const list = items();
      const idx = list.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' || e.key === 'Down') {
        e.preventDefault();
        (list[idx + 1] || list[0]).focus();
      } else if (e.key === 'ArrowUp' || e.key === 'Up') {
        e.preventDefault();
        (list[idx - 1] || list[list.length - 1]).focus();
      }
    });

    dd.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' || e.key === 'Esc') {
        close();
        toggle.focus();
      }
    });

    dd.addEventListener('focusout', (e) => {
      if (!dd.contains(e.relatedTarget)) close();
    });

    document.addEventListener('click', (e) => {
      if (!dd.contains(e.target)) close();
    });
  });

  const promoPopup = document.querySelector('[data-promo-popup]');
  if (promoPopup) {
    const STORAGE_KEY = 'promoPopupDismissed';
    const justSubscribed = window.location.search.indexOf('customer_posted=true') !== -1;
    let isOpen = false;

    const openPopup = () => {
      if (isOpen) return;
      isOpen = true;
      promoPopup.classList.add('is-open');
      promoPopup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };

    const closePopup = () => {
      isOpen = false;
      promoPopup.classList.remove('is-open');
      promoPopup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
    };

    promoPopup.querySelectorAll('[data-popup-close]').forEach((el) => {
      el.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen) closePopup();
    });

    const copyBtn = promoPopup.querySelector('[data-popup-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', () => {
        const code = copyBtn.getAttribute('data-code') || '';
        const done = () => {
          copyBtn.classList.add('is-copied');
          const label = copyBtn.querySelector('small');
          if (label) label.textContent = 'Copied!';
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else {
          done();
        }
      });
    }

    if (justSubscribed && promoPopup.querySelector('[data-popup-success]')) {
      openPopup();
    } else {
      let dismissed = false;
      try { dismissed = localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) {}
      if (!dismissed) {
        const delay = (parseFloat(promoPopup.getAttribute('data-popup-delay')) || 3) * 1000;
        setTimeout(openPopup, delay);
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-eyebrow-ticker]').forEach((ticker) => {
    const items = Array.from(ticker.querySelectorAll('.hero__ticker-item'));
    if (items.length < 2) return;
    // Reduced motion: the first message stays put.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let current = 0;
    setInterval(() => {
      const prev = items[current];
      prev.classList.remove('is-active');
      prev.classList.add('is-leaving');
      setTimeout(() => prev.classList.remove('is-leaving'), 600);
      current = (current + 1) % items.length;
      items[current].classList.add('is-active');
    }, 3800);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-account-dashboard]');
    if (!root) return;
    const addingText = root.getAttribute('data-adding-text') || 'Adding\u2026';

    root.querySelectorAll('[data-account-atc]').forEach(function (btn) {
      btn.addEventListener('click', async function () {
        if (btn.disabled) return;
        const originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = addingText;

        const payload = { id: Number(btn.dataset.variantId), quantity: 1 };
        const planId = btn.dataset.sellingPlanId;
        if (planId) payload.selling_plan = Number(planId);

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });
          if (!res.ok) {
            const err = await res.json().catch(function () { return {}; });
            throw new Error(err.description || 'Could not add to cart');
          }
          window.location.href = '/cart';
        } catch (e) {
          btn.textContent = e.message;
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 3500);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (function () {
    // Confirm before deleting an address.
    document.querySelectorAll('.customer__delete-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var message = form.dataset.confirm || 'Delete this address?';
        if (!window.confirm(message)) e.preventDefault();
      });
    });

    // Populate the province select from the chosen country's data-provinces.
    document.querySelectorAll('[data-address-country]').forEach(function (countrySelect) {
      var wrapper = countrySelect.closest('form');
      if (!wrapper) return;
      var provinceField = wrapper.querySelector('[data-province-field]');
      var provinceSelect = wrapper.querySelector('[data-address-province]');
      if (!provinceField || !provinceSelect) return;

      // Preselect the saved country (all_country_option_tags has no selected state).
      var savedCountry = countrySelect.dataset.default;
      if (savedCountry) countrySelect.value = savedCountry;

      function updateProvinces() {
        var option = countrySelect.options[countrySelect.selectedIndex];
        var raw = option ? option.getAttribute('data-provinces') : null;
        var provinces = [];
        try { provinces = raw ? JSON.parse(raw) : []; } catch (e) { provinces = []; }

        provinceSelect.innerHTML = '';
        if (!provinces.length) {
          provinceField.hidden = true;
          return;
        }
        provinces.forEach(function (pair) {
          var opt = document.createElement('option');
          opt.value = pair[0];
          opt.textContent = pair[1];
          if (provinceSelect.dataset.selected === pair[0]) opt.selected = true;
          provinceSelect.appendChild(opt);
        });
        provinceField.hidden = false;
      }

      countrySelect.addEventListener('change', updateProvinces);
      updateProvinces();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  (function () {
    const loginView = document.querySelector('[data-login-view]');
    const recoverView = document.querySelector('[data-recover-view]');
    if (!loginView || !recoverView) return;

    const choiceView = document.querySelector('[data-login-choice]');
    const passwordLogin = document.querySelector('[data-password-login]');
    const passwordToggle = document.querySelector('[data-show-password]');

    function showPasswordLogin() {
      if (!choiceView || !passwordLogin) return;
      choiceView.hidden = true;
      passwordLogin.hidden = false;
      if (passwordToggle) passwordToggle.setAttribute('aria-expanded', 'true');
    }

    function showChoice() {
      if (!choiceView || !passwordLogin) return;
      passwordLogin.hidden = true;
      choiceView.hidden = false;
      if (passwordToggle) passwordToggle.setAttribute('aria-expanded', 'false');
    }

    function showRecover(show) {
      loginView.hidden = show;
      recoverView.hidden = !show;
    }

    document.querySelectorAll('[data-show-password]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        showPasswordLogin();
      });
    });
    document.querySelectorAll('[data-show-choice]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        showChoice();
      });
    });
    document.querySelectorAll('[data-show-recover]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        showRecover(true);
      });
    });
    document.querySelectorAll('[data-show-login]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        showRecover(false);
        // recover is only reachable from the password form, so return there
        showPasswordLogin();
      });
    });

    // A failed password attempt re-renders the page on the chooser view -
    // reopen the form so the error is visible.
    if (passwordLogin && passwordLogin.querySelector('.customer__errors')) showPasswordLogin();
    if (window.location.hash === '#password-login') showPasswordLogin();
    if (window.location.hash === '#recover') showRecover(true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  const page = document.querySelector('[data-search-page]');
  if (page) {
    // Sort: submit on change (the <noscript> "Go" button covers no-JS)
    const sortSelect = page.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        const form = sortSelect.closest('form');
        if (form) form.submit();
      });
    }

    // Highlight the searched words inside result titles
    const terms = (page.getAttribute('data-terms') || '')
      .trim()
      .split(/\s+/)
      .filter((w) => w.length >= 2)
      .map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));

    if (terms.length) {
      const re = new RegExp('(' + terms.join('|') + ')', 'gi');
      page.querySelectorAll('.product-card__title, .sr-card__title').forEach((el) => {
        // Titles are plain text, so a textContent swap is safe here
        const text = el.textContent;
        if (!re.test(text)) return;
        re.lastIndex = 0;
        el.innerHTML = text
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(re, '<mark>$1</mark>');
      });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var popup = document.querySelector('[data-video-popup]');
    if (!popup) return;

    var DISMISS_KEY = 'wwf-video-popup-dismissed';
    try {
      if (sessionStorage.getItem(DISMISS_KEY)) return;
    } catch (e) {}

    var video = popup.querySelector('video');
    var card = popup.querySelector('.video-popup__card');
    var expandBtn = popup.querySelector('[data-video-popup-expand]');
    var minimiseBtn = popup.querySelector('[data-video-popup-minimise]');
    var closeBtn = popup.querySelector('[data-video-popup-close]');

    // Cinematic entrance: title card on a dark curtain, letterbox bars, sparkles
    popup.hidden = false;
    popup.classList.add('video-popup--intro');
    setTimeout(function () {
      popup.classList.remove('video-popup--intro');
    }, 5200);

    // --- Drag to move + resize from edges/corners ---
    var POS_KEY = 'wwf-video-popup-layout';
    var drag = null;
    var lastDragEnd = 0;

    function currentPos() {
      var r = popup.getBoundingClientRect();
      return { left: r.left, bottom: window.innerHeight - r.bottom };
    }

    function setPos(left, bottom) {
      var r = card.getBoundingClientRect();
      var maxLeft = Math.max(window.innerWidth - r.width - 8, 8);
      var maxBottom = Math.max(window.innerHeight - r.height - 8, 8);
      popup.style.left = Math.min(Math.max(left, 8), maxLeft) + 'px';
      popup.style.bottom = Math.min(Math.max(bottom, 8), maxBottom) + 'px';
      popup.style.right = 'auto';
    }

    function saveLayout() {
      try {
        var pos = currentPos();
        sessionStorage.setItem(POS_KEY, JSON.stringify({
          left: pos.left,
          bottom: pos.bottom,
          width: card.style.width ? card.getBoundingClientRect().width : null
        }));
      } catch (e) {}
    }

    try {
      var saved = JSON.parse(sessionStorage.getItem(POS_KEY) || 'null');
      if (saved) {
        if (saved.width) card.style.width = saved.width + 'px';
        if (saved.left != null) setPos(saved.left, saved.bottom);
      }
    } catch (e) {}

    function applyResize(d, dx, dy) {
      var aspect = d.startW / d.startH;
      var w = d.startW;
      if (d.mode.indexOf('e') > -1) w = d.startW + dx;
      if (d.mode.indexOf('w') > -1) w = d.startW - dx;
      if (d.mode === 'n') w = d.startW - dy * aspect;
      if (d.mode === 's') w = d.startW + dy * aspect;
      w = Math.min(Math.max(w, 130), Math.min(window.innerWidth - 16, 720));
      var dw = w - d.startW;
      var dh = dw / aspect;
      var left = d.startLeft;
      var bottom = d.startBottom;
      if (d.mode.indexOf('w') > -1) left = d.startLeft - dw;
      if (d.mode.indexOf('s') > -1) bottom = d.startBottom - dh;
      card.style.width = w + 'px';
      setPos(left, bottom);
    }

    popup.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest('.video-popup__bar-btn') || e.target.closest('.video-popup__link')) return;
      var handle = e.target.closest('[data-video-popup-resize]');
      var rect = card.getBoundingClientRect();
      var pos = currentPos();
      drag = {
        mode: handle ? handle.getAttribute('data-video-popup-resize') : 'move',
        cursor: handle ? getComputedStyle(handle).cursor : 'grabbing',
        pointerId: e.pointerId,
        startX: e.clientX,
        startY: e.clientY,
        startLeft: pos.left,
        startBottom: pos.bottom,
        startW: rect.width,
        startH: rect.height,
        moved: false
      };
      if (handle) e.preventDefault();
    });

    window.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.pointerId) return;
      var dx = e.clientX - drag.startX;
      var dy = e.clientY - drag.startY;
      if (!drag.moved) {
        if (Math.abs(dx) < 5 && Math.abs(dy) < 5) return;
        drag.moved = true;
        popup.classList.add(drag.mode === 'move' ? 'video-popup--dragging' : 'video-popup--resizing');
        document.documentElement.style.cursor = drag.cursor;
        try {
          popup.setPointerCapture(drag.pointerId);
        } catch (err) {}
      }
      e.preventDefault();
      if (drag.mode === 'move') {
        setPos(drag.startLeft + dx, drag.startBottom - dy);
      } else {
        applyResize(drag, dx, dy);
      }
    });

    function endDrag(e) {
      if (!drag || (e && e.pointerId !== drag.pointerId)) return;
      var didMove = drag.moved;
      drag = null;
      popup.classList.remove('video-popup--dragging', 'video-popup--resizing');
      document.documentElement.style.cursor = '';
      if (didMove) {
        lastDragEnd = Date.now();
        saveLayout();
      }
    }

    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);

    // Keep the card on screen if the window shrinks after it's been moved
    window.addEventListener('resize', function () {
      if (!popup.style.left) return;
      var pos = currentPos();
      setPos(pos.left, pos.bottom);
    });

    var soundBlocked = false;

    function setSound(on) {
      if (!video) return;
      if (on) {
        video.muted = false;
        var p = video.play();
        if (p && p.then) {
          p.then(function () {
            soundBlocked = false;
            popup.classList.add('video-popup--sound-on');
          }).catch(function () {
            // Browser blocked unmuted playback (no user gesture yet) - stay muted
            soundBlocked = true;
            video.muted = true;
            var rp = video.play();
            if (rp && rp.catch) rp.catch(function () {});
          });
        } else {
          popup.classList.add('video-popup--sound-on');
        }
      } else {
        video.muted = true;
        popup.classList.remove('video-popup--sound-on');
      }
    }

    // Hover = sound on; leave = sound off (while minimised)
    popup.addEventListener('mouseenter', function () {
      setSound(true);
    });

    popup.addEventListener('mouseleave', function () {
      if (popup.classList.contains('video-popup--minimised')) {
        setSound(false);
      }
    });

    // If the browser blocked hover-audio, retry on the visitor's first click/tap
    document.addEventListener('pointerdown', function () {
      if (soundBlocked && popup.matches(':hover')) {
        setSound(true);
      }
    });

    function setMinimised(minimised) {
      popup.classList.toggle('video-popup--minimised', minimised);
      expandBtn.setAttribute('aria-expanded', String(!minimised));
      if (minimised) {
        setSound(false);
      } else if (video) {
        // Expanding restarts the film from the top, sound on - like an intro
        video.currentTime = 0;
        setSound(true);
      }
    }

    var clickAction = popup.getAttribute('data-click-action');
    var clickUrl = popup.getAttribute('data-click-url');

    expandBtn.addEventListener('click', function () {
      if (Date.now() - lastDragEnd < 300) return;
      if (clickAction === 'link' && clickUrl) {
        window.location.href = clickUrl;
        return;
      }
      if (popup.classList.contains('video-popup--minimised')) {
        setMinimised(false);
      }
    });

    minimiseBtn.addEventListener('click', function () {
      setMinimised(true);
    });

    closeBtn.addEventListener('click', function () {
      popup.hidden = true;
      if (video) video.pause();
      try {
        sessionStorage.setItem(DISMISS_KEY, '1');
      } catch (e) {}
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.classList.contains('video-popup--minimised')) {
        setMinimised(true);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
